<template>
  <div>
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">系统配置</h4>
        </Row>
        <Alert v-if="submitError" show-icon type="error">{{ errorMsg }}</Alert>
        <div v-if="loading">
          <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>加载中</div>
          </Spin>
        </div>
        <Alert v-else-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right" v-on:click="init"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <Row v-else>
          <Col :md="{ span: 12, offset: 6 }">
            <Form :rules="rules" ref="nodeForm" :model="node">
              <FormItem label="认证服务API（如：http://127.0.0.1:35357）" prop="identity_api">
                <Input v-model="node.identity_api"/>
              </FormItem>
              <FormItem label="计算服务API（如：http://127.0.0.1:8774）" prop="compute_api">
                <Input v-model="node.compute_api"/>
              </FormItem>
              <FormItem label="镜像服务API（如：http://127.0.0.1:9292）" prop="image_api">
                <Input v-model="node.image_api"/>
              </FormItem>
              <FormItem label="网络服务API（如：http://127.0.0.1:9696）" prop="network_api">
                <Input v-model="node.network_api"/>
              </FormItem>
              <FormItem label="存储服务API（如：http://127.0.0.1:8776）" prop="volume_api">
                <Input v-model="node.volume_api"/>
              </FormItem>
              <FormItem label="域名称" prop="domain_name">
                <Input v-model="node.domain_name"/>
              </FormItem>
              <FormItem label="默认租户ID" prop="default_project_id">
                <Input v-model="node.default_project_id"/>
              </FormItem>
              <FormItem label="管理员用户名" prop="admin_username">
                <Input v-model="node.admin_username"/>
              </FormItem>
              <FormItem label="管理员密码" prop="admin_password">
                <Input v-model="node.admin_password" type="password"/>
              </FormItem>
            </Form>
            <Row style="text-align: left">
              <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交</Button>
              <Button @click.native="$router.push({name: 'privateCloudMain'})">取消</Button>
              <Button type="error" style="float: right;" @click="clear" :loading="submitting">清空配置</Button>
            </Row>
          </Col>
        </Row>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudNodeInfo, renewPrivateCloudNode, clearPrivateCloudNode } from '@/api/private-cloud/node'

export default {
  name: 'setting',
  data () {
    return {
      node: {
        identity_api: '',
        compute_api: '',
        image_api: '',
        network_api: '',
        volume_api: '',
        domain_name: 'Default',
        default_project_id: '',
        admin_username: '',
        admin_password: ''
      },
      rules: {
        identity_api: { required: true, message: '认证服务API不能为空', trigger: 'blur' },
        compute_api: { required: true, message: '计算服务API不能为空', trigger: 'blur' },
        image_api: { required: true, message: '镜像服务API不能为空', trigger: 'blur' },
        network_api: { required: true, message: '网络服务API不能为空', trigger: 'blur' },
        volume_api: { required: true, message: '存储服务API不能为空', trigger: 'blur' },
        domain_name: { required: true, message: '区域名称不能为空', trigger: 'blur' },
        default_project_id: { required: true, message: '默认租户ID不能为空', trigger: 'blur' },
        admin_username: { required: true, message: '管理员用户名不能为空', trigger: 'blur' },
        admin_password: { required: true, message: '管理员密码不能为空', trigger: 'blur' }
      },
      error: false,
      submitError: false,
      errorMsg: '',
      loading: false,
      submitting: false
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getNode()
    },
    getNode () {
      this.loading = true
      getPrivateCloudNodeInfo().then(res => {
        this.loading = false
        this.node = res.data
        this.error = false
      }).catch(res => {
        this.loading = false
        this.error = true
        console.error(res.response)
      })
    },
    submit () {
      let reqData = {
        identity_api: this.node.identity_api,
        compute_api: this.node.compute_api,
        image_api: this.node.image_api,
        network_api: this.node.network_api,
        volume_api: this.node.volume_api,
        domain_name: this.node.domain_name,
        default_project_id: this.node.default_project_id,
        admin_username: this.node.admin_username,
        admin_password: this.node.admin_password
      }
      this.submitting = true
      renewPrivateCloudNode(reqData).then(res => {
        this.submitting = false
        this.$router.push({name: 'privateCloudMain'})
        this.$Notice.success({title: '操作成功'})
        this.submitError = false
        this.errorMsg = ''
      }).catch(res => {
        this.submitting = false
        this.submitError = true
        console.error(res.response)
        this.errorMsg = res.response.data
        this.$Notice.error({title: '操作失败'})
      })
    },
    clear () {
      this.$Modal.confirm({
        title: '清空配置',
        content: '确认后将清除所有配置、激活用户和操作日志，确定要清空配置吗?',
        onOk: () => {
          this.submitting = true
          clearPrivateCloudNode().then(res => {
            this.init()
            this.$Notice.success({title: '操作成功'})
            this.submitError = false
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            this.submitError = true
            console.error(res.response)
            this.errorMsg = res.response.data
            this.$Notice.error({title: '操作失败'})
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../base.less';
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
